<template>
    <div justify="center" class="pb-6 ma-0">

        <page-hero
            :heroImage="heroImage"
            :pageTitle="pageTitle"
            :imageAltText="imageAltText"
        ></page-hero>

        <v-container style="max-width: 1185px">

            <page-subheading title="A Message From the Executive Committee"></page-subheading>

            <v-row
                class="py-6"
                align="center"
                justify="center"
            >
                <v-col
                    cols="12"
                    md="8"
                    lg="7"
                    class="mx-auto mx-sm-auto mx-md-0"
                >
                    <executive-committee-message></executive-committee-message>
                </v-col>

                <v-col
                    cols="12"
                    md="4"
                    lg="5"
                    align="center"
                >
                    <leadership-card
                        v-bind:leader="ceo"
                        :corner="'bottom-right'"
                        :mediumScreen="true"
                    ></leadership-card>
                </v-col>
            </v-row>

            <v-row
                class="py-6"
                align="center"
                justify="center"
            >
                <v-col
                    cols="12"
                    md="4"
                    lg="5"
                    align="center"
                >
                    <leadership-card
                        v-bind:leader="deputyCEO"
                        :corner="'bottom-right'"
                        :mediumScreen="true"
                    ></leadership-card>
                </v-col>

                <v-col
                    cols="12"
                    md="8"
                    lg="7"
                    class="mx-auto mx-sm-auto mx-md-0"
                >
                    <deputy-ceo-message></deputy-ceo-message>
                </v-col>
            </v-row>
        </v-container>

        <v-container style="max-width: 1185px">
            <v-row>
                <v-col class="d-flex justify-center ma-10">
                    <page-subheading title="Meet Our Leaders"></page-subheading>
                </v-col>
            </v-row>

            <leadership-carousel :leaders="leaders"></leadership-carousel>
        </v-container>
    </div>
</template>

<script>
import DeputyCeoMessage from '@/components/leadership/DeputyCeoMessage.vue'
import ExecutiveCommitteeMessage from '@/components/leadership/ExecutiveCommitteeMessage.vue'
import LeadershipCard from '@/components/leadership/LeadershipCard.vue'
import LeadershipCarousel from '@/components/leadership/LeadershipCarousel.vue'
import PageHero from '@/components/PageHero.vue'
import PageSubheading from '@/components/PageSubheading.vue'

export default {
    components: {
        'deputy-ceo-message': DeputyCeoMessage,
        'executive-committee-message': ExecutiveCommitteeMessage,
        'leadership-card': LeadershipCard,
        'leadership-carousel': LeadershipCarousel,
        'page-hero': PageHero,
        'page-subheading': PageSubheading
    },
    data: () => {
        return {
            heroImage: require('@/assets/leadership/leadership_hero1800x1200.jpg'),
            pageTitle: "Leadership",
            imageAltText: "Stock image of a business meeting",
            leaders: [
                {
                    id: 1,
                    title: "Director of Finance/IT",
                    fullName: "Brian Roberts",
                    image: require('@/assets/leadership/brian_roberts_400x400.jpg'),
                    quote: `In the dynamic world of finance, our team stands as a 
                    beacon of resilience and innovation.  Each day presents new
                    challenges and opportunities, and it is through our collective
                    expertise and unwavering dedication that we navigate them
                    successfully.  Our commitment to excellence drives us to
                    continuously improve, adapt, and grow.  We are not just
                    managing numbers; we are crafting strategies that fuel growth
                    and secure futures.  Together, we transform complexities into
                    clear, actionable insights, and our synergy turns goals into
                    achievements.  We push boundaries, support one another, and
                    strive for greatness, knowing our efforts create a lasting impact.`,
                    shortQuote: `In the dynamic world of finance, our team
                    stands as a beacon of resilience and innovation. Our
                    commitment to excellence drives us to continuously improve,
                    adapt, and grow.  We are not just managing numbers; we are
                    crafting strategies that fuel growth and secure futures. 
                    Together, we transform complexities into clear, actionable
                    insights, and our synergy turns goals into achievements. 
                    We push boundaries, support one another, and strive for 
                    greatness, knowing our efforts create a lasting impact.`
                },
                {
                    id: 2,
                    title: "Plant Manager",
                    fullName: "Dean Kato",
                    image: require('@/assets/leadership/dean_kato_400x400.jpg'),
                    quote: `Our Production, Materials, Logistics, and Planning
                    teams constantly strive to deliver the excellent products
                    to our customers. Through teamwork, we achieve remarkable
                    results, continuously contributing to the overall success
                    of our business. With hard work and dedication to our goals,
                    we consistently provide innovative solutions.`
                },
                {
                    id: 3,
                    title: "General Manager of Human Resources & Administration",
                    fullName: "Jennie Dranschak",
                    image: require('@/assets/leadership/jennie_dranschak_400x400.jpg'),
                    quote: `At Prospira, we know that people are our most
                    valuable asset and we try everyday to find ways to prove
                    that to our team. Recognizing that we work to support our
                    lives and not live our lives to work, we constantly strive
                    to protect a work/life balance. Sometimes, our customer
                    needs dictate that more work is needed, but we are always
                    refining our processes to make sure that we are working
                    smarter, not harder. We have a great group of Teammates
                    doing great things!`
                },
                {
                    id: 4,
                    title: "General Manager of Sales",
                    fullName: "Kaz Tanaka",
                    image: require('@/assets/leadership/kaz_tanaka_400x400.jpg'),
                    quote: `The Sales team is working for both our customer and
                    our company. We are always focused on serving society
                    through our superior quality to our valued customer.
                    Contributing to our customer’s success and our growth is
                    our greatest happiness.`
                },
                {
                    id: 5,
                    title: "General Manager of Purchasing",
                    fullName: "Ricky Pang",
                    image: require('@/assets/leadership/ricky_pang_400x400.jpg'),
                    quote: `Prospira purchasing is continuously developing a
                    sustainable and competitive supply chain. We believe
                    fairness, respect, transparency and continuous improvement
                    are the keys to build strong relationships with our suppliers
                    and are the foundation of a stable supply chain. We are
                    always in pursuit of supplying our customers and society with
                    superior quality.`
                },
                {
                    id: 6,
                    title: "General Manager of Engineering",
                    fullName: "Andy Ealy",
                    image: require('@/assets/leadership/andy_ealy_400x400.jpg'),
                    quote: `At Prospira, engineering and maintenance are a critical 
                    part of the foundation that enables us to deliver on our mission 
                    of Serving Society with Superior Quality. Every system we support, 
                    every process we improve, and every challenge we solve reflects 
                    our commitment to safety, quality, and innovation. By empowering 
                    our teams, leveraging data-driven decision making, and 
                    strengthening cross-functional collaboration, we foster a culture 
                    of technical excellence and continuous improvement that 
                    drives customer value and operational success.`
                },
            ],
            ceo: {
                id: 10,
                title: "Global CEO",
                fullName: "John Li",
                image: require('@/assets/leadership/john_li_400x400.jpg'),
                quote: `We are a component company dedicated to automotive rubber 
                products for anti-vibration, noise reduction, and improving driving 
                harshness. We have over 89 years of experience in developing and 
                manufacturing anti-vibration rubber products. Through continuous 
                improvement and innovation, we have become a leader in global NVH solutions.

                We practice the concept of serving society with superior quality, 
                always adhering to the principle of safety first, and pursuing 
                environmentally friendly principles for the current and future 
                generations. We respect our employees and provide diverse training 
                courses to help them grow together with our company. We deeply 
                clear the social responsibility of corporation and are committed 
                to building a better society.

                In order to cope with more uncertainties and challenges in the 
                future, we will continuously improve and innovate, and use BI 
                systems to ensure the company's sustainable and healthy development, 
                providing more value to customers, suppliers, shareholders and society.`
            },
            deputyCEO: {
                id: 11,
                title: "President/CEO",
                fullName: "David Shen",
                image: require('@/assets/leadership/david_shen_400x400.jpg'),
                quote: `We are a component company dedicated to automotive rubber 
                    products for anti-vibration, noise reduction, and improving driving 
                    harshness. We have over 89 years of experience in developing and 
                    manufacturing anti-vibration rubber products. Through continuous 
                    improvement and innovation, we have become a leader in global NVH solutions.

                    We practice the concept of serving society with superior quality, 
                    always adhering to the principle of safety first, and pursuing 
                    environmentally friendly principles for the current and future 
                    generations. We respect our employees and provide diverse training 
                    courses to help them grow together with our company. We deeply 
                    clear the social responsibility of corporation and are committed 
                    to building a better society.

                    In order to cope with more uncertainties and challenges in the 
                    future, we will continuously improve and innovate, and use BI 
                    systems to ensure the company's sustainable and healthy development, 
                    providing more value to customers, suppliers, shareholders and society.`
            }
        }
    }
}
</script>
